import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

// Import components
import SideMenuBar from './components/SideMenuBar';
import TopBar from './components/TopBar';
import Login from './app/auth/Login';
import DailyScriptureForm from './app/qt/DailyScriptureForm';
import DailyScriptureList from './app/qt/DailyScriptureList';
import UserList from './app/users/UserList';
import DailyScriptureBulkUpload from './app/qt/DailyScriptureBulkUpload';
import BibleStudyList from './app/bibleStudy/BibleStudyList';
import BibleStudyDetail from './app/bibleStudy/BibleStudyDetail';
import FamilyWorshipList from './app/familyWorship/FamilyWorshipList';
import FamilyWorshipDetail from './app/familyWorship/FamilyWorshipDetail';
import QtVideoInfoList from './app/qt/QtVideoInfoList';
import QtAudioInfoList from './app/qt/QtAudioInfoList';
import QuizSetList from './app/quiz/QuizSetList';
import QuizSetDetail from './app/quiz/QuizSetDetail';
import BibleJsonUpload from './app/bible/BibleJsonUpload';
import BibleList from './app/bible/BibleList';
import BibleDetail from './app/bible/BibleDetail';
import PushManage from './app/push/PushManage';
import ImageManagement from './app/imageManagement/ImageManagement';
import ImageManagementMonthList from './app/imageManagement/ImageManagementMonthList';
import MyWork from './app/myWork/MyWork';
import Dashboard from './app/dashboard/Dashboard';
import CommonMessageList from './app/commonMessage/CommonMessageList';
import CommonMessageDetail from './app/commonMessage/CommonMessageDetail';
import AdCardList from './app/adCard/AdCardList';
import AdCardDetail from './app/adCard/AdCardDetail';
import InquiriesList from './app/inquiries/InquiriesList';
import InquiryDetail from './app/inquiries/InquiryDetail';

// Import styles
import 'startbootstrap-sb-admin-2/css/sb-admin-2.min.css';
import 'startbootstrap-sb-admin-2/vendor/fontawesome-free/css/all.min.css';


const App = () => {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getSession = async () => {
            try {
                const { data, error } = await supabase.auth.getSession();
                if (error) throw error;
                setSession(data.session);
            } catch (error) {
                console.error('Error getting session:', error.message);
            } finally {
                setLoading(false);
            }
        };

        getSession();

        const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session);
        });

        return () => {
            authListener.subscription.unsubscribe();
        };
    }, []);

    if (loading) {
        return <div>Loading...</div>; // Or a proper spinner component
    }

    return (
        <Router>
            <div id="wrapper">
                {session ? <AuthenticatedApp user={session.user} /> : <Login />}
            </div>
        </Router>
    );
};

const AuthenticatedApp = ({ user }) => {
    return (
        <>
            <SideMenuBar />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar user={user} />
                    <div className="container-fluid">
                        <Routes>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/users" element={<UserList />} />
                            <Route path="/qt/DailyScriptureList" element={<DailyScriptureList />} />
                            <Route path="/qt/DailyScriptureBulkUpload" element={<DailyScriptureBulkUpload />} />
                            <Route path="/qt/DailyScriptureForm/new" element={<DailyScriptureForm />} />
                            <Route path="/qt/DailyScriptureForm/:id" element={<DailyScriptureForm />} />
                            <Route path="/qt/videos" element={<QtVideoInfoList />} />
                            <Route path="/qt/audios" element={<QtAudioInfoList />} />
                            <Route path="/quiz" element={<QuizSetList />} />
                            <Route path="/quiz/new" element={<QuizSetDetail />} />
                            <Route path="/quiz/:id" element={<QuizSetDetail />} />
                            <Route path="/bible-study" element={<BibleStudyList />} />
                            <Route path="/bible-study/new" element={<BibleStudyDetail />} />
                            <Route path="/bible-study/:id" element={<BibleStudyDetail />} />
                            <Route path="/bible-json-upload" element={<BibleJsonUpload />} />
                            <Route path="/bible" element={<BibleList />} />
                            <Route path="/bible/:bookCode" element={<BibleDetail />} />
                            <Route path="/family-worship" element={<FamilyWorshipList />} />
                            <Route path="/family-worship/new" element={<FamilyWorshipDetail />} />
                            <Route path="/family-worship/:id" element={<FamilyWorshipDetail />} />
                            <Route path="/push" element={<PushManage />} />
                            <Route path="/image-management" element={<ImageManagementMonthList />} />
                            <Route path="/image-management/detail" element={<ImageManagement />} />
                            <Route path="/my-work" element={<MyWork />} />
                            <Route path="/common-messages" element={<CommonMessageList />} />
                            <Route path="/common-messages/new" element={<CommonMessageDetail />} />
                            <Route path="/common-messages/:id" element={<CommonMessageDetail />} />
                            <Route path="/ad-cards" element={<AdCardList />} />
                            <Route path="/ad-cards/new" element={<AdCardDetail />} />
                            <Route path="/ad-cards/:id" element={<AdCardDetail />} />
                            <Route path="/inquiries" element={<InquiriesList />} />
                            <Route path="/inquiries/:id" element={<InquiryDetail />} />
                            {/* Add other routes here */}
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </>
    );
};

export default App;
